import { Button } from "@chakra-ui/react";
import { PlusMath } from "@airhelp/icons";

interface AddConnectionButtonProps {
  onClick: () => void;
}

export const AddConnectionButton = ({ onClick }: AddConnectionButtonProps) => (
  <Button justifySelf="flex-start" size="xs" variant="subtle" leftIcon={<PlusMath />} onClick={onClick}>
    Add connecting flight
  </Button>
);
